exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-enter-active,.v-leave-active{transition:all .3s ease}.v-enter{transform:translateX(-100px);opacity:0}.v-leave-to{transform:translateX(100px);opacity:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-dfcd96a6","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/objects/ui/TransitionCard.vue
// module id = 84
// module chunks = 0